import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { fiveInfra } from '@/mocks/jiuchou-architecture';

export default function InfraLayer() {
  return (
    <section className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            dark
            eyebrow="第四层 · 数字基础设施层"
            title="五大数字基础设施"
            subtitle="TOMA 智能体、数字货架、ePin、数字消费、智能清分，五项核心技术协同构成完整的乡村数字经济操作系统。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {fiveInfra.map((item, i) => (
            <Reveal key={item.no} delay={i * 80}>
              <div className="h-full p-6 rounded-lg bg-foreground-900 border border-foreground-700 hover:border-primary-500/50 transition-colors flex flex-col">
                <div className="flex items-center justify-between">
                  <div className="w-12 h-12 rounded-lg bg-accent-500/20 flex items-center justify-center">
                    <i className={`${item.icon} text-accent-300 text-2xl`}></i>
                  </div>
                  <span className="font-heading font-bold text-2xl text-foreground-700">{item.no}</span>
                </div>
                <h3 className="mt-4 font-heading font-bold text-lg text-background-50">{item.name}</h3>
                <div className="mt-1 text-sm text-primary-300 font-medium">{item.tag}</div>
                <div className="mt-3 flex flex-wrap gap-2">
                  {item.roles.map((r) => (
                    <span
                      key={r}
                      className="px-2.5 py-1 text-[11px] rounded-full bg-background-50/10 border border-background-50/15 text-background-100 whitespace-nowrap"
                    >
                      {r}
                    </span>
                  ))}
                </div>
                <p className="mt-4 text-sm text-foreground-300 leading-relaxed">{item.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}